import { Divider } from '@material-ui/core';
import dayjs from 'dayjs';
import React from 'react';
import { roundToTwo } from '../../components/OrderListTable/utils/roundToTwo';
import { CourierScore } from '../../fetch/CourierScore';
import './CourierScoreList.scss';
import { CouriersScoreTimeline } from './CouriersScoreTimeline';

function seconds_to_days_hours_mins_secs_str(seconds: number): {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
} {
  const days = Math.floor(seconds / (24 * 60 * 60));
  seconds -= days * (24 * 60 * 60);

  const hours = Math.floor(seconds / (60 * 60));
  seconds -= hours * (60 * 60);
  const minutes = Math.floor(seconds / 60);
  seconds -= minutes * 60;

  return { days, hours, minutes, seconds };
}

function formatCountDownString(
  days: number,
  hours: number,
  minutes: number,
  seconds: number
): string {
  const dayText = 0 < days ? `${days} days, ` : '';
  const hoursText = 0 < hours ? `${hours} hours,` : '';
  const minutesText =
    0 < minutes
      ? minutes === 1
        ? ` ${minutes} minute and `
        : ` ${minutes} minutes and `
      : '';
  const secondsText = seconds > 0 ? `${seconds}s` : '0s';

  return dayText + hoursText + minutesText + secondsText;
}

function getOrdersPerHour(
  totalDeliveries: number,
  hours: number,
  minutes: number
): number {
  return roundToTwo(totalDeliveries / (hours + minutes / 60));
}

export function CourierScoreList({
  couriersScore,
}: {
  couriersScore: CourierScore;
}): JSX.Element {
  if (couriersScore === null) {
    return (
      <div>
        <Divider />
        <CouriersScoreTimeline
          startTime={''}
          endTime={''}
          totalDeliveries={0}
          averageRating={0}
          ordersPerHour={0}
          counterText={null}
        />
      </div>
    );
  } else {
    const secondsDiff = dayjs(couriersScore.endTime).diff(
      dayjs(couriersScore.startTime),
      'second'
    );
    const { days, hours, minutes, seconds } =
      seconds_to_days_hours_mins_secs_str(secondsDiff);
    const counterText = formatCountDownString(days, hours, minutes, seconds);
    const ordersPerHour = getOrdersPerHour(
      couriersScore.totalDeliveries,
      hours,
      minutes
    );

    return (
      <div>
        <Divider />
        <CouriersScoreTimeline
          startTime={
            couriersScore.startTime
              ? dayjs(couriersScore.startTime).format('HH:mm')
              : ''
          }
          endTime={
            couriersScore.endTime
              ? dayjs(couriersScore.endTime).format('HH:mm')
              : ''
          }
          totalDeliveries={
            couriersScore.totalDeliveries ? couriersScore.totalDeliveries : 0
          }
          averageRating={
            couriersScore.averageRating ? couriersScore.averageRating : 0
          }
          ordersPerHour={ordersPerHour ? ordersPerHour : 0}
          counterText={counterText}
        />
        <Divider />
      </div>
    );
  }
}
